import React from 'react';
import { toast } from '../../hooks/use-toast';
import { apiTestingTranslator } from '../../translations/apiTesting';

export function apiTestingFeedback(language) {
  const t = apiTestingTranslator(language);
  const notify = (message, type) => toast({
    title: language === 'es'
      ? { success: 'Éxito', error: 'Error', warning: 'Advertencia', info: 'Información' }[type]
      : { success: 'Success', error: 'Error', warning: 'Warning', info: 'Info' }[type],
    description: t(message), duration: 5000,
    ...(type === 'error' ? { variant: 'destructive' } : {}),
    ...(type === 'success' ? { className: 'bg-green-50 border-green-200' } : {}),
    ...(type === 'warning' ? { className: 'bg-yellow-50 border-yellow-200' } : {}),
  });
  return {
    showSuccess: (message) => notify(message, 'success'),
    showError: (message) => notify(message, 'error'),
    showWarning: (message) => notify(message, 'warning'),
    showInfo: (message) => notify(message, 'info'),
  };
}

export function showJiraTicketSuccess(issueKey, issueUrl, language) {
  const t = apiTestingTranslator(language);
  toast({ title: t('Jira Ticket Created Successfully!'), duration: 5000,
    className: 'bg-green-50 border-green-200', description: <div>
      <p>{t('Issue {v0} has been created.', { v0: issueKey })}</p>
      <a href={issueUrl} target="_blank" rel="noopener noreferrer" className="underline">{t('View in Jira')}</a>
    </div>,
  });
}
